import { Selector } from 'reselect'

import {
  GlobalLoadingProps,
} from '../../types/app'

import {
  RootState,
} from '../../types/store'

export const globalLoading: Selector<RootState, GlobalLoadingProps> = (state) => state.network.globalLoading

export default {
  globalLoading,
}